// extracted by mini-css-extract-plugin
export default {"title":"MeetupList-module--title--othtk"};